/* Лепкавата лента се показва чак когато мястото за поръчка е излязло
   от екрана нагоре. Ако човек го вижда, лентата е излишна.

   Смята се от позицията на ориентира при скролване, а не с
   IntersectionObserver — той мълчи в някои вградени браузъри и тогава
   лентата не се появява изобщо.

   Ориентирът се търси измежду няколко възможности, защото на различните
   страници блокът за поръчка е различен. Ако нищо не се намери, се минава
   на разстояние от върха — така лентата работи навсякъде. */
(function () {
  'use strict';

  var SELECTORS = [
    '#lp-size',
    '.lp-size',
    '.lp-hero',
    '.quantity-breaks',
    '.product-form__submit',
    'button[name="add"]',
    '.product-form__input',
    'form[action*="/cart/add"]'
  ];

  var FALLBACK_OFFSET = 700;

  function findTarget() {
    for (var i = 0; i < SELECTORS.length; i++) {
      var el = document.querySelector(SELECTORS[i]);
      // Празна обвивка не става за ориентир — Shrine държи формата с нулева височина.
      if (el && el.offsetHeight > 0) return el;
    }
    return null;
  }

  /* Колко сме скролнали — тялото понякога е скролващият елемент, а не прозорецът. */
  function scrolled() {
    return window.pageYOffset ||
           (document.scrollingElement && document.scrollingElement.scrollTop) ||
           document.documentElement.scrollTop ||
           document.body.scrollTop || 0;
  }

  function init() {
    var bar = document.querySelector('[data-lp-sticky]');
    if (!bar) return;
    if (bar.dataset.lpStickyOn === '1') return;
    bar.dataset.lpStickyOn = '1';

    bindCta(bar);

    var ticking = false;
    var shown = null;

    function check() {
      ticking = false;

      var target = findTarget();
      var passed;

      if (target) {
        // Излязъл е нагоре, когато долният му ръб е над видимата област.
        passed = target.getBoundingClientRect().bottom < 0;
      } else {
        passed = scrolled() > FALLBACK_OFFSET;
      }

      if (passed !== shown) {
        shown = passed;
        bar.hidden = !passed;
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      // Без rAF в някои вградени браузъри — тогава смятаме веднага.
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(check);
      } else {
        check();
      }
    }

    // Слуша се на трите места, защото скролващият елемент се различава по тема.
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });

    check();
  }

  /* Бутонът скролва до блока за поръчка, ако той е на същата страница.
     Ако не е — линкът си работи както е зададен. */
  function bindCta(bar) {
    var cta = bar.querySelector('.lp-sticky__cta');
    if (!cta) return;

    cta.addEventListener('click', function (e) {
      var goal = findTarget();
      if (!goal) return;              // няма къде да скролнем — следвай линка

      e.preventDefault();
      goal.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Подсказваме къде е, за да не се чуди човек какво стана.
      goal.classList.add('lp-flash');
      setTimeout(function () { goal.classList.remove('lp-flash'); }, 1200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    var bar = document.querySelector('[data-lp-sticky]');
    if (bar) bar.dataset.lpStickyOn = '';
    init();
  });
})();
